export function startTimer(duration, display, onComplete) {
    let start = Date.now(),
        diff,
        minutes,
        seconds,
        intervalId;

    function timer() {
        diff = duration - (((Date.now() - start) / 1000) | 0);
        minutes = (diff / 60) | 0;
        seconds = (diff % 60) | 0;

        minutes = minutes < 10 ? "0" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;

        display.textContent = minutes + ":" + seconds;

        if (diff <= 0) {
            display.textContent = "00:00";
            clearInterval(intervalId);
            if (onComplete && typeof onComplete === 'function') {
                onComplete();
            }
        }
    }

    timer();
    intervalId = setInterval(timer, 1000);
    return intervalId; // Return so it can be cleared externally if needed
}

export function startTimerFromEndDate(endDate, display, onComplete) {
    const endTime = new Date(endDate).getTime();
    const now = Date.now();
    let remainingSeconds = Math.max(0, Math.floor((endTime - now) / 1000));

    if (remainingSeconds <= 0) {
        display.textContent = "00:00";
        if (onComplete) onComplete();
        return null;
    }

    return startTimer(remainingSeconds, display, onComplete);
}